
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAABRUExURQAAAP////////////////////////////////// /////9vg68XO39Pa577H24udwL3H3JKjxPHz97bB2LbB16GvzNTa55qpyMzU4/j5+wAAAI0yd28A AAAKdFJOUwBAj9/PnyAQkD+yeUh8AAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEwAACxMBAJqcGAAA AAd0SU1FB+cMBAM5IlSlicsAAACbSURBVCjPtZIBDsIgDEVLgTE7lYHCtvtfVHCDRUM1LvGFBPJf WkgoQEKgpBeU7mDF9NQAzdMpaqKy7YkBATpiEaB5iVBvHM4bl5JIKKerrYwlq3J31n2S9mfp8+4Z ectvvR9sO7AytQ3HXvsX6eJkQ7DT7HZZRit6WuYlLfJxixQg/9kaBC/TeLKl+G00wTRr16FOdPqt WuIp5w/cRyBfK4iSfAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMy0xMi0wNFQwMjozMjoxMCswMDow MMHnuWsAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjMtMTItMDRUMDI6MzI6MTArMDA6MDCwugHXAAAA KHRFWHRkYXRlOnRpbWVzdGFtcAAyMDIzLTEyLTA0VDAzOjU3OjM0KzAwOjAwgs/b5AAAAABJRU5E rkJggg=="}})])
          )
        }
      }
    